angular.module('westBerkshireEvents.clearUrlParams').directive('fdClearUrlParams', () => {
    return {
        bindings: {
            selectFilter: '<',
            filterValues: '<',
            onFilterChanged: '&'
        },
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: wbClearUrlParams
    };
});

function wbClearUrlParams($scope, $attrs, $rootScope, $log, $location) {
    $location.search({});
}


// WEBPACK FOOTER //
// ../src/public/javascripts/clear-url-params/clear-url-params.directive.js